import { useEffect, useState } from 'react';
import { Modal } from '../../components/Modal';
import { api, ApiError } from '../../lib/api';

// Resultados do questionario de toda a equipe (admin/gerente). Uma linha por tentativa, a mais
// recente primeiro — o questionario so' registra (decisao do Ruan), entao aqui e' onde o
// registro serve pra alguma coisa.

type Linha = {
  id: number;
  usuario: string;
  login: string;
  video_slug: string;
  video_titulo: string | null;
  acertos: number;
  total: number;
  criado_em: string;
};

// So' o titulo: a numeracao (1.01) depende da secao e da ordem de hoje, e a tentativa e' de ontem.
function tituloVideo(l: Linha): string {
  return l.video_titulo ?? l.video_slug;
}

export function ModalResultados({ onFechar }: { onFechar: () => void }) {
  const [linhas, setLinhas] = useState<Linha[] | null>(null);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    api.get<Linha[]>('/api/treinamento/resultados')
      .then(setLinhas)
      .catch((e) => setErro(e instanceof ApiError ? e.message : 'Não foi possível carregar.'));
  }, []);

  return (
    <Modal
      aberto
      onFechar={onFechar}
      titulo="Resultados do questionário"
      largura={820}
      rodape={<button type="button" onClick={onFechar} className="btn-secundario px-4 py-2 rounded-md">Fechar</button>}
    >
      {erro && <p className="text-sm font-bold">{erro}</p>}
      {!erro && linhas === null && <p className="text-sm text-gray-500">Carregando...</p>}
      {linhas && linhas.length === 0 && (
        <p className="text-sm text-gray-600">Ninguém respondeu nenhum questionário ainda.</p>
      )}
      {linhas && linhas.length > 0 && (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-gray-600 border-b border-gray-200">
              <th className="py-2 pr-3">Quando</th>
              <th className="py-2 pr-3">Pessoa</th>
              <th className="py-2 pr-3">Vídeo</th>
              <th className="py-2 text-right">Acertos</th>
            </tr>
          </thead>
          <tbody>
            {linhas.map((l) => (
              <tr key={l.id} className="border-b border-gray-100">
                <td className="py-2 pr-3 whitespace-nowrap">
                  {new Date(l.criado_em).toLocaleString('pt-BR', {
                    day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
                  })}
                </td>
                <td className="py-2 pr-3">{l.usuario}</td>
                <td className="py-2 pr-3">{tituloVideo(l)}</td>
                <td className="py-2 text-right font-bold whitespace-nowrap">{l.acertos} de {l.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Modal>
  );
}
